import React from 'react';
import { VIDEO_ENTRY } from '../../data/concert-data';
import DateHeading from './date-heading.component';
import Quote from './quote.component';
import YouTube from './youtube.component';

/*===========================================================*/
// Concert Entry MAIN function
/*===========================================================*/
export const ConcertEntry: React.FC<VIDEO_ENTRY> = ({ date, html, youtubeId }) => (
   <div className="mx-auto my-4 pb-4 bg-gray-600 rounded-xl shadow-md"
   >
      <DateHeading date={date} />
      <Quote html={html} />
      <YouTube id={youtubeId} />
   </div>
);
